import React, { useEffect, createElement } from 'react';
type Props = {
  id: string;
  data: Record<string, unknown>;
};
/**
 * Injects a JSON-LD structured-data script into <head>.
 * Helps search engines understand the band as a MusicGroup / LocalBusiness.
 */
export function StructuredData({
  id,
  data
}: Props) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    let script = document.head.querySelector<HTMLScriptElement>(`script[data-seo-id="${id}"]`);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-id', id);
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [id, data]);
  return null;
}